import { packageListApi } from "./api";

export const getMaterialSets = async (params) => {
  try {
    const res = await packageListApi.getMaterialSets(params);
    return res?.data;
  } catch (e) {
    return [];
  }
};

export const updMaterialSets = async (body) => {
  try {
    const res = await packageListApi.updMaterialSets(body);
    return res?.data;
  } catch (e) {}
};

export const deleteMaterial = async (body) => {
  try {
    const res = await packageListApi.deleteMaterial(body);
    return res?.data;
  } catch (e) {}
};

export const packageTableColumns = [
  {
    name: "material_set_id",
    required: true,
    label: "ID",
    align: "center",
    field: "material_set_id",
    sortable: true,
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
  {
    name: "set_name",
    required: true,
    label: "Набор",
    align: "left",
    field: "set_name",
    sortable: true,
    headerStyle: "width: 100px",
    style: "width: 100px",
  },
  {
    name: "materials",
    required: true,
    label: "Материалы",
    align: "center",
    field: "materials",
    sortable: true,
  },
  {
    name: "action",
    required: true,
    label: "",
    align: "center",
    headerStyle: "width: 50px",
    style: "width: 50px",
  },
];
